export const categories = {
    shoes: "Shoes", clothes: "Clothes", bags: "Bags", accessories: "Accessories"
}
export const store =


    [{
        id: 'SKU4728',
        name: 'Navy Geo Print Sleeveless Dress',
        price: 84,
        type: 'ourBestSellers',
        category: 'Clothes',
        primaryImage: require('../assets/products/Navy Geo Print Sleeveless Dress.png'),
        hoverImg: require('../assets/products/Navy Geo Print Sleeveless Dress.png'),
        product_category: 'Fashion'
    }, {
        id: 'SKU4187',
        name: 'Peach Polka Flutter-Sleeve Dress',
        price: 90,
        type: 'ourBestSellers',
        category: 'Clothes',
        primaryImage: require('../assets/products/Peach Polka Flutter-Sleeve Dress.png'),
        hoverImg: require('../assets/products/Peach Polka Flutter-Sleeve Dress.png'),
        product_category: 'Fashion'
    }, {
        id: 'SKU1496',
        name: 'Golden Sun Midi Dress',
        price: 95,
        type: 'ourBestSellers',
        category: 'Clothes',
        primaryImage: require('../assets/products/Golden Sun Midi Dress.png'),
        hoverImg: require('../assets/products/Golden Sun Midi Dress.png'),
        product_category: 'Fashion'
    }, {
        id: 'SKU6540',
        name: 'White Ruffle Hem Maxi Dress',
        price: 120,
        type: 'ourBestSellers',
        category: 'Clothes',
        primaryImage: require('../assets/products/White Ruffle Hem Maxi Dress.png'),
        hoverImg: require('../assets/products/White Ruffle Hem Maxi Dress.png'),
        product_category: 'Fashion'
    }, {
        id: 'SKU7070',
        name: 'Blush Pink Spaghetti Strap Gown',
        price: 105,
        type: 'ourBestSellers',
        category: 'Clothes',
        primaryImage: require('../assets/products/Blush Pink Spaghetti Strap Gown.png'),
        hoverImg: require('../assets/products/Blush Pink Spaghetti Strap Gown.png'),
        product_category: 'Fashion'
    }, {
        id: 'SKU4080',
        name: 'Bohemian Multi-Colored Scarf',
        price: 115,
        type: 'ourBestSellers',
        category: 'Clothes',
        primaryImage: require('../assets/products/Bohemian Multi-Colored Scarf.png'),
        hoverImg: require('../assets/products/Bohemian Multi-Colored Scarf.png'),
        product_category: 'Fashion'
    }, {
        id: 'SKU2099',
        name: 'Pastel Abstract Geometric Scarf',
        price: 100,
        type: 'navbar-BodyType',
        category: 'Clothes',
        primaryImage: require('../assets/products/Pastel Abstract Geometric Scarf.png'),
        hoverImg: require('../assets/products/Pastel Abstract Geometric Scarf.png'),
        product_category: 'Fashion'
    }, {
        id: 'SKU3349',
        name: 'Blush Pink Knit Cardigan',
        price: 75,
        type: 'navbar-BodyType',
        category: 'Clothes',
        primaryImage: require('../assets/products/Blush Pink Knit Cardigan.png'),
        hoverImg: require('../assets/products/Blush Pink Knit Cardigan.png'),
        product_category: 'Fashion'
    }, {
        id: 'SKU2247',
        name: 'Cream Classic Knit Cardigan',
        price: 80,
        type: 'navbar-BodyType',
        category: 'Clothes',
        primaryImage: require('../assets/products/Cream Classic Knit Cardigan.png'),
        hoverImg: require('../assets/products/Cream Classic Knit Cardigan.png'),
        product_category: 'Fashion'
    }, {
        id: 'SKU3422',
        name: 'Mint Zip-Up Belted Jumpsuit',
        price: 99,
        type: 'navbar-TravelType',
        category: 'Clothes',
        primaryImage: require('../assets/products/Mint Zip-Up Belted Jumpsuit.png'),
        hoverImg: require('../assets/products/Mint Zip-Up Belted Jumpsuit.png'),
        product_category: 'Fashion'
    }, {
        id: 'SKU5296',
        name: 'Camel Power Suit Jumpsuit',
        price: 88,
        type: 'navbar-TravelType',
        category: 'Clothes',
        primaryImage: require('../assets/products/Camel Power Suit Jumpsuit.png'),
        hoverImg: require('../assets/products/Camel Power Suit Jumpsuit.png'),
        product_category: 'Fashion'
    }, {
        id: 'SKU898',
        name: 'The Ravello Loafer',
        price: 180,
        type: 'loafer',
        category: 'Shoes',
        stars: 5,
        descr: 'Inspired by coastal getaways, this sophisticated loafer in black features a sleek design, ultra-cushy insoles and durable outsoles. Comfort you can wear all day—from morning espresso to evening Aperol spritz.',
        primaryImage: 'https://rothys.com/cdn/shop/files/123_RavelloLoafer_StoneBlack_OnFigure_0730_650x.jpg?v=1699033803',
        hoverImg: 'https://rothys.com/cdn/shop/files/123_RavelloLoafer_StoneBlack_OnFigure_0730_650x.jpg?v=1699033803',
        product_category: 'Shoes'
    }, {
        id: 'SKU8353',
        name: 'The Sand Loafer',
        price: 200,
        type: 'bestSellers',
        category: 'Shoes',
        stars: 5,
        descr: 'Inspired by coastal getaways, this sophisticated loafer in black features a sleek design, ultra-cushy insoles and durable outsoles. Comfort you can wear all day—from morning espresso to evening Aperol spritz.',
        primaryImage: 'https://images.unsplash.com/photo-1615979474401-8a6a344de5bd?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bG9hZmVyfGVufDB8fDB8fHwy',
        hoverImg: 'https://images.unsplash.com/photo-1615979474401-8a6a344de5bd?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bG9hZmVyfGVufDB8fDB8fHwy',
        product_category: 'Shoes'
    }, {
        id: 'SKU5574',
        name: 'The Navy Loafer',
        price: 180,
        type: 'loafer',
        category: 'Shoes',
        stars: 5,
        descr: 'Inspired by coastal getaways, this sophisticated loafer in black features a sleek design, ultra-cushy insoles and durable outsoles. Comfort you can wear all day—from morning espresso to evening Aperol spritz.',
        primaryImage: 'https://images.unsplash.com/photo-1616406432452-07bc5938759d?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8bG9hZmVyfGVufDB8fDB8fHwy',
        hoverImg: 'https://images.unsplash.com/photo-1616406432452-07bc5938759d?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8bG9hZmVyfGVufDB8fDB8fHwy',
        product_category: 'Shoes'
    }, {
        id: 'SKU8971',
        name: 'The Boot Sneakers',
        price: 201,
        type: 'loafer',
        category: 'Shoes',
        stars: 5,
        descr: 'Inspired by coastal getaways, this sophisticated loafer in black features a sleek design, ultra-cushy insoles and durable outsoles. Comfort you can wear all day—from morning espresso to evening Aperol spritz.',
        primaryImage: 'https://rothys.com/cdn/shop/products/056_Hudson_pdp_B_650x.jpg?v=1628807453',
        hoverImg: 'https://rothys.com/cdn/shop/products/056_Hudson_pdp_B_650x.jpg?v=1628807453',
        product_category: 'Shoes'
    }, {
        id: 'SKU6832',
        name: 'The Arctic Sneakers',
        price: 201,
        type: 'shoe',
        category: 'Shoes',
        stars: 5,
        descr: 'Inspired by coastal getaways, this sophisticated loafer in black features a sleek design, ultra-cushy insoles and durable outsoles. Comfort you can wear all day—from morning espresso to evening Aperol spritz.',
        primaryImage: 'https://rothys.com/cdn/shop/files/056_RS01_ArcticStone_Side_650x.jpg?v=1706919590',
        hoverImg: 'https://rothys.com/cdn/shop/files/056_RS01_ArcticStone_Side_650x.jpg?v=1706919590',
        product_category: 'Shoes'
    }, {
        id: 'SKU8863',
        name: 'Full zip jacket',
        price: 30,
        type: 'bestSeller',
        category: 'Clothes',
        stars: 5,
        descr: 'The next generation of our lightweight, four-way stretch soft shell jacket features a brushed interior for even more comfort.',
        primaryImage: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8amFja2V0fGVufDB8fDB8fHwy',
        hoverImg: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8amFja2V0fGVufDB8fDB8fHwy',
        product_category: 'Fashion'
    }, {
        id: 'SKU7480',
        name: 'Long puffer jacket',
        price: 40,
        type: 'jacket',
        category: 'Clothes',
        stars: 5,
        descr: 'The next generation of our lightweight, four-way stretch soft shell jacket features a brushed interior for even more comfort.',
        primaryImage: 'https://www.proozy.com/cdn/shop/products/196601110672-jpg-6.jpg?v=1708947832&width=900',
        hoverImg: 'https://www.proozy.com/cdn/shop/products/196601110672-jpg-6.jpg?v=1708947832&width=900',
        product_category: 'Fashion'
    }, {
        id: 'SKU7836',
        name: 'Nexus puffer jacket',
        price: 30,
        type: 'jacket',
        category: 'Clothes',
        stars: 5,
        descr: 'The next generation of our lightweight, four-way stretch soft shell jacket features a brushed interior for even more comfort.',
        primaryImage: 'https://images.unsplash.com/photo-1611312449408-fcece27cdbb7?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8amFja2V0fGVufDB8fDB8fHwy',
        hoverImg: 'https://images.unsplash.com/photo-1611312449408-fcece27cdbb7?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8amFja2V0fGVufDB8fDB8fHwy',
        product_category: 'Fashion'
    }, {
        id: 'SKU2664',
        name: 'scarf',
        price: 30,
        type: 'accessories',
        category: 'Accessories',
        stars: 5,
        descr: 'The no-sacrifices carry-on that’s rugged enough to handle whatever travel throws your way.',
        primaryImage: 'https://images.unsplash.com/photo-1457545195570-67f207084966?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8c2NhcmZ8ZW58MHx8MHx8fDA%3D',
        hoverImg: 'https://images.unsplash.com/photo-1457545195570-67f207084966?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8c2NhcmZ8ZW58MHx8MHx8fDA%3D',
        product_category: 'Fashion'
    }, {
        id: 'SKU6719',
        name: 'Check scarf',
        price: 30,
        type: 'bestSeller',
        category: 'Accessories',
        stars: 5,
        descr: "What's winter without a check scarf?",
        primaryImage: 'https://images.unsplash.com/photo-1609803384069-19f3e5a70e75?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8c2NhcmZ8ZW58MHx8MHx8fDI%3D',
        hoverImg: 'https://images.unsplash.com/photo-1609803384069-19f3e5a70e75?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8c2NhcmZ8ZW58MHx8MHx8fDI%3D',
        product_category: 'Fashion'
    }, {
        id: 'SKU5058',
        name: 'Glasses',
        price: 30,
        type: 'accessories',
        category: 'Accessories',
        stars: 5,
        descr: 'Yellow glasses',
        primaryImage: 'https://images.unsplash.com/photo-1565624473621-4368231d26c5?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8Z2xhc3NlfGVufDB8fDB8fHwy',
        hoverImg: 'https://images.unsplash.com/photo-1565624473621-4368231d26c5?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8Z2xhc3NlfGVufDB8fDB8fHwy',
        product_category: 'Fashion'
    }, {
        id: 'SKU4881',
        name: 'Glasses 2',
        price: 30,
        type: 'accessories',
        category: 'Accessories',
        stars: 5,
        descr: 'Reading glasses',
        primaryImage: 'https://images.unsplash.com/photo-1602703522866-fb486308da5d?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8Z2xhc3NlfGVufDB8fDB8fHwy',
        hoverImg: 'https://images.unsplash.com/photo-1602703522866-fb486308da5d?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8Z2xhc3NlfGVufDB8fDB8fHwy',
        product_category: 'Fashion'
    }, {
        id: 'SKU702',
        name: 'Phone cover',
        price: 30,
        type: 'bestSeller',
        category: 'Accessories',
        stars: 5,
        descr: 'Phone cover',
        primaryImage: 'https://images.unsplash.com/photo-1581003989510-ba20094d343c?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cGhvbmUlMjBjb3ZlcnxlbnwwfHwwfHx8Mg%3D%3D',
        hoverImg: 'https://images.unsplash.com/photo-1581003989510-ba20094d343c?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cGhvbmUlMjBjb3ZlcnxlbnwwfHwwfHx8Mg%3D%3D',
        product_category: 'Electronics'
    }, {
        id: 'SKU9406',
        name: '3L BAG',
        price: 40,
        type: 'bag',
        category: 'Bags',
        stars: 5,
        descr: 'Keep everything you need for a day on the water — out of the water..',
        primaryImage: 'https://yeti-web.imgix.net/56b3cdd3970cc189/W-2301…w=500&q=68&h=500&fit=fill&hattr=500px&wattr=500px',
        hoverImg: 'https://yeti-web.imgix.net/56b3cdd3970cc189/W-2301…w=500&q=68&h=500&fit=fill&hattr=500px&wattr=500px',
        product_category: 'Fashion'
    }, {
        id: 'SKU4046',
        name: '35 CARRYALL TOTE BAG',
        price: 140,
        type: 'bag',
        category: 'Bags',
        stars: 5,
        descr: 'Not too small, not too big, perfectly tough.',
        primaryImage: 'https://yeti-web.imgix.net/58e9190b07ab82db/W-2300…w=500&q=68&h=500&fit=fill&hattr=500px&wattr=500px',
        hoverImg: 'https://yeti-web.imgix.net/56b3cdd3970cc189/W-2301…w=500&q=68&h=500&fit=fill&hattr=500px&wattr=500px',
        product_category: 'Fashion'
    }, {
        id: 'SKU398',
        name: '28L WATERPROOF BAG',
        price: 140,
        type: 'bag',
        category: 'Bags',
        stars: 5,
        descr: 'Not too small, not too big, perfectly tough.',
        primaryImage: 'https://yeti-web.imgix.net/68938bb60b4815f0/W-site…w=500&q=68&h=500&fit=fill&hattr=500px&wattr=500px',
        hoverImg: 'https://yeti-web.imgix.net/68938bb60b4815f0/W-site…w=500&q=68&h=500&fit=fill&hattr=500px&wattr=500px',
        product_category: 'Fashion'
    }, {
        id: 'SKU246',
        name: '35L WHEELED LUGGAGE',
        price: 350,
        type: 'bag',
        category: 'Bags',
        stars: 5,
        descr: 'The no-sacrifices carry-on that’s rugged enough to handle whatever travel throws your way.',
        primaryImage: 'https://yeti-web.imgix.net/339fa08e1dbd2fbf/W-Bags…w=500&q=68&h=500&fit=fill&hattr=500px&wattr=500px',
        hoverImg: 'https://yeti-web.imgix.net/339fa08e1dbd2fbf/W-Bags…w=500&q=68&h=500&fit=fill&hattr=500px&wattr=500px',
        product_category: 'Fashion'
    }]